/* INTERVENTIONS */
export const FETCH_INTERVENTIONS_REQUEST = 'FETCH_INTERVENTIONS_REQUEST';
export const FETCH_INTERVENTIONS_SUCCESS = 'FETCH_INTERVENTIONS_SUCCESS';
export const FETCH_INTERVENTIONS_FAILURE = 'FETCH_INTERVENTIONS_FAILURE';

export const SET_INTERVENTIONS_FILTERS = 'SET_INTERVENTIONS_FILTERS'; // shared interventions filter
export const SET_INTERVENTIONS_SENDER_FILTER_MODE = 'INTERVENTIONS/FILTERS/SET_SENDER_FILTER_MODE';
export const REMOVE_INTERVENTION_FILTER = 'INTERVENTIONS/FILTERS/REMOVE_FILTER';
export const CLEAR_INTERVENTIONS_FILTERS = 'CLEAR_INTERVENTIONS_FILTERS';

export const CLEAR_INTERVENTIONS_TEMPORARY_FILTERS = 'CLEAR_INTERVENTIONS_TEMPORARY_FILTERS';
export const TOGGLE_QUICK_FILTER = 'INTERVENTIONS/FILTERS/TOGGLE_QUICK_FILTER';

export const FETCH_INTERVENTION_REQUEST = 'FETCH_INTERVENTION_REQUEST';
export const FETCH_INTERVENTION_SUCCESS = 'FETCH_INTERVENTION_SUCCESS';
export const FETCH_INTERVENTION_FAILURE = 'FETCH_INTERVENTION_FAILURE';
export const SELECT_INTERVENTION = 'SELECT_INTERVENTION';

export const UPDATE_INTERVENTION_STATUS_REQUEST = 'UPDATE_INTERVENTION_STATUS_REQUEST';
export const UPDATE_INTERVENTION_STATUS_SUCCESS = 'UPDATE_INTERVENTION_STATUS_SUCCESS';
export const UPDATE_INTERVENTION_STATUS_FAILURE = 'UPDATE_INTERVENTION_STATUS_FAILURE';

export const FETCH_INTERVENTIONS_STATUS_REQUEST = 'FETCH_INTERVENTIONS_STATUS_REQUEST';
export const FETCH_INTERVENTIONS_STATUS_SUCCESS = 'FETCH_INTERVENTIONS_STATUS_SUCCESS';
export const FETCH_INTERVENTIONS_STATUS_FAILURE = 'FETCH_INTERVENTIONS_STATUS_FAILURE';

export const CREATE_INTERVENTION_REQUEST = 'CREATE_INTERVENTION_REQUEST';
export const CREATE_INTERVENTION_SUCCESS = 'CREATE_INTERVENTION_SUCCESS';
export const CREATE_INTERVENTION_FAILURE = 'CREATE_INTERVENTION_FAILURE';

export const DELETE_INTERVENTION_REQUEST = 'DELETE_INTERVENTION_REQUEST';
export const DELETE_INTERVENTION_SUCCESS = 'DELETE_INTERVENTION_SUCCESS';
export const DELETE_INTERVENTION_FAILURE = 'DELETE_INTERVENTION_FAILURE';

export const UPDATE_INTERVENTION_REQUEST = 'UPDATE_INTERVENTION_REQUEST';
export const UPDATE_INTERVENTION_SUCCESS = 'UPDATE_INTERVENTION_SUCCESS';
export const UPDATE_INTERVENTION_FAILURE = 'UPDATE_INTERVENTION_FAILURE';

export const POST_DUPLICATE_INTERVENTION = 'POST_DUPLICATE_INTERVENTION_REQUEST';
export const POST_DUPLICATE_INTERVENTION_SUCCESS = 'POST_DUPLICATE_INTERVENTION_SUCCESS';
export const POST_DUPLICATE_INTERVENTION_FAILURE = 'POST_DUPLICATE_INTERVENTION_FAILURE';
export const OPEN_DUPLICATE_MODAL = 'OPEN_DUPLICATE_MODAL';
export const CLOSE_DUPLICATE_MODAL = 'CLOSE_DUPLICATE_MODAL';
export const OPEN_UNIQUE_VIDEO_MODAL = 'OPEN_UNIQUE_VIDEO_MODAL';
export const CLOSE_UNIQUE_VIDEO_MODAL = 'CLOSE_UNIQUE_VIDEO_MODAL';
export const SEND_UNIQUE_VIDEO_REQUEST = 'SEND_UNIQUE_VIDEO_REQUEST';
export const SEND_UNIQUE_VIDEO_SUCCESS = 'SEND_UNIQUE_VIDEO_SUCCESS';
export const SEND_UNIQUE_VIDEO_FAILURE = 'SEND_UNIQUE_VIDEO_FAILURE';

export const OPEN_CREATE_INTERVENTION_MODAL = 'OPEN_CREATE_INTERVENTION_MODAL';
export const CLOSE_CREATE_INTERVENTION_MODAL = 'CLOSE_CREATE_INTERVENTION_MODAL';

/* INTERVENTION LINK */
export const RESET_INTERVENTION_LINK_REQUEST = 'RESET_INTERVENTION_LINK_REQUEST';
export const FETCH_INTERVENTION_LINK_REQUEST = 'FETCH_INTERVENTION_LINK_REQUEST';
export const FETCH_INTERVENTION_LINK_FAILURE = 'FETCH_INTERVENTION_LINK_FAILURE';
export const FETCH_INTERVENTION_LINK_SUCCESS = 'FETCH_INTERVENTION_LINK_SUCCESS';

export const FETCH_INTERVENTION_PAYMENT_HISTORY_REQUEST = 'FETCH_INTERVENTION_PAYMENT_HISTORY_REQUEST';
export const FETCH_INTERVENTION_PAYMENT_HISTORY_SUCCESS = 'FETCH_INTERVENTION_PAYMENT_HISTORY_SUCCESS';
export const FETCH_INTERVENTION_PAYMENT_HISTORY_FAILURE = 'FETCH_INTERVENTION_PAYMENT_HISTORY_FAILURE';

export const CREATE_INTERVENTION_REMINDER_REQUEST = 'CREATE_INTERVENTION_REMINDER_REQUEST';
export const CREATE_INTERVENTION_REMINDER_SUCCESS = 'CREATE_INTERVENTION_REMINDER_SUCCESS';
export const CREATE_INTERVENTION_REMINDER_FAILURE = 'CREATE_INTERVENTION_REMINDER_FAILURE';
export const CLEAR_CREATE_INTERVENTION_REMINDER_ERROR = 'CLEAR_CREATE_INTERVENTION_REMINDER_ERROR';

/* DELAY REMINDER */
export const DELAY_REMINDER_REQUEST = 'DELAY_REMINDER_REQUEST';
export const DELAY_REMINDER_SUCCESS = 'DELAY_REMINDER_SUCCESS';
export const DELAY_REMINDER_FAILURE = 'DELAY_REMINDER_FAILURE';

export const READ_INTERVENTION_MESSAGES_REQUEST = 'READ_INTERVENTION_MESSAGES_REQUEST';
export const READ_INTERVENTION_MESSAGES_SUCCESS = 'READ_INTERVENTION_MESSAGES_SUCCESS';
export const READ_INTERVENTION_MESSAGES_FAILURE = 'READ_INTERVENTION_MESSAGES_FAILURE';

export const FETCH_INTERVENTIONS_PDF = 'FETCH_INTERVENTIONS_PDF_REQUEST';
export const FETCH_INTERVENTIONS_PDF_SUCCESS = 'FETCH_INTERVENTIONS_PDF_SUCCESS';
export const FETCH_INTERVENTIONS_PDF_FAILURE = 'FETCH_INTERVENTIONS_PDF_FAILURE';

export const INIT_DASHBOARD = 'INTERVENTIONS/INIT/DASHBOARD';
export const FETCH_INTERVENTIONS_START_POLLING = 'FETCH_INTERVENTIONS/FETCH/START_POLLING';
export const FETCH_INTERVENTIONS_STOP_POLLING = 'FETCH_INTERVENTIONS/FETCH/STOP_POLLING';

export const SET_SCHEDULABLE_TYPE = 'INTERVENTIONS/UI/DASHBOARD/SET_TYPE';
export const SET_SORT = 'INTERVENTIONS/UI/DASHBOARD/SET_SORT';

export const PRINT_FO_QR_CODE = 'INTERVENTION/DETAIL/PRINT/FO_QR_CODE';

export const OPEN_APPROVE_MANUALLY_MODAL = 'INTERVENTION/APPROVE_MANUALLY/OPEN_MODAL';
export const CLOSE_APPROVE_MANUALLY_MODAL = 'INTERVENTION/APPROVE_MANUALLY/CLOSE_MODAL';

export const APPROVE_MANUALLY_REQUEST = 'INTERVENTION/APPROVE_MANUALLY/REQUEST';
export const APPROVE_MANUALLY_SUCCESS = 'INTERVENTION/APPROVE_MANUALLY/SUCCESS';
export const APPROVE_MANUALLY_FAILURE = 'INTERVENTION/APPROVE_MANUALLY/FAILURE';

export const INTERVENTION_IS_READY = 'INTERVENTION/DETAIL/READY';

export const REBRAND_REQUEST = 'INTERVENTION/REBRAND/REQUEST';
export const REBRAND_SUCCESS = 'INTERVENTION/REBRAND/SUCCESS';
export const REBRAND_FAILURE = 'INTERVENTION/REBRAND/FAILURE';

/* Generic fetch */
export const INTERVENTIONS_FETCH = 'INTERVENTIONS/FETCH/REQUEST';
export const INTERVENTIONS_FETCH_SUCCESS = 'INTERVENTIONS/FETCH/SUCCESS';
export const INTERVENTIONS_FETCH_FAILURE = 'INTERVENTIONS/FETCH/FAILURE';

export const OPEN_SEND_MODAL = 'INTERVENTION/SEND/OPEN_SEND_MODAL';
export const CLOSE_SEND_MODAL = 'INTERVENTION/SEND/CLOSE_SEND_MODAL';

export const OPEN_TSCANS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/MODAL/OPEN_TSCANS';
export const OPEN_AUDITS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/MODAL/OPEN_AUDITS';

export const CLOSE_TSCANS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/MODAL/CLOSE_TSCANS';
export const CLOSE_AUDITS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/MODAL/CLOSE_AUDITS';

export const IMPORT_AUDITS_OR_TSCANS = 'INTERVENTION/IMPORTS/TSCANS_OR_AUDITS_REQUEST';
export const IMPORT_AUDITS_OR_TSCANS_SUCCESS = 'INTERVENTION/IMPORTS/TSCANS_OR_AUDITS_SUCCESS';
export const IMPORT_AUDITS_OR_TSCANS_FAILURE = 'INTERVENTION/IMPORTS/TSCANS_OR_AUDITS_FAILURE';

export const IMPORT_CHECKLISTS_GROUPS = 'INTERVENTION/IMPORTS/CHECKLISTS_GROUPS_REQUEST';
export const IMPORT_CHECKLISTS_GROUPS_SUCCESS = 'INTERVENTION/IMPORTS/CHECKLISTS_GROUPS_SUCCESS';
export const IMPORT_CHECKLISTS_GROUPS_FAILURE = 'INTERVENTION/IMPORTS/CHECKLISTS_GROUPS_FAILURE';

export const IMPORT_WORKS_INTO_INTERVENTION = 'INTERVENTION/WORKS_ORDER/IMPORT_REQUEST';
export const IMPORT_WORKS_INTO_INTERVENTION_SUCCESS = 'INTERVENTION/WORKS_ORDER/IMPORT_SUCCESS';
export const IMPORT_WORKS_INTO_INTERVENTION_FAILURE = 'INTERVENTION/WORKS_ORDER/IMPORT_FAILURE';

export const GET_WORKS_ORDER_BY_REPARATION_ORDER = 'INTERVENTION/WORKS_ORDER/FETCH_REQUEST';
export const FETCH_WORKS_ORDER_SUCCESS = 'INTERVENTION/WORKS_ORDER/FETCH_SUCCESS';
export const FETCH_WORKS_ORDER_FAILURE = 'INTERVENTION/WORKS_ORDER/FETCH_FAILURE';

export const SET_SHOW_IMPORTED_WORK = 'INTERVENTION/SET/IMPORTED_WORK';

export const OPEN_WORK_ORDER_MODAL = 'INTERVENTION/WORK_ORDER/OPEN_MODAL';
export const CLOSE_WORK_ORDER_MODAL = 'INTERVENTION/WORK_ORDER/CLOSE_MODAL';

export const OPEN_WORK_ORDER_ERROR_MODAL = 'INTERVENTION/WORK_ORDER/OPEN_ERROR_MODAL';
export const CLOSE_WORK_ORDER_ERROR_MODAL = 'INTERVENTION/WORK_ORDER/CLOSE_ERROR_MODAL';

export const INTERVENTION_INVOICE_PATCH_STATUS = 'INTERVENTION/INVOICE/STATUS/PATCH_REQUEST';
export const INTERVENTION_INVOICE_PATCH_STATUS_SUCCESS = 'INTERVENTION/INVOICE/STATUS/PATCH_SUCCESS';
export const INTERVENTION_INVOICE_PATCH_STATUS_FAILURE = 'INTERVENTION/INVOICE/STATUS/PATCH_FAILURE';

export const MEDIARIES_EXPORT = 'INTERVENTION/MEDIARIES/EXPORT_REQUEST';
export const MEDIARIES_EXPORT_SUCCESS = 'INTERVENTION/MEDIARIES/EXPORT_SUCCESS';
export const MEDIARIES_EXPORT_FAILURE = 'INTERVENTION/MEDIARIES/EXPORT_FAILURE';

export const FETCH_KANBAN_INTERVENTIONS = 'INTERVENTIONS/KANBAN/FETCH_REQUEST';
export const FETCH_KANBAN_INTERVENTIONS_SUCCESS = 'INTERVENTIONS/KANBAN/FETCH_SUCCESS';
export const FETCH_KANBAN_INTERVENTIONS_FAILURE = 'INTERVENTIONS/KANBAN/FETCH_FAILURE';

export const SET_KANBAN_INTERVENTION_FILTER = 'INTERVENTIONS/KANBAN/SET/FILTER';
export const SET_KANBAN_SENDER_FILTER_MODE = 'INTERVENTIONS/KANBAN/FILTERS/SET_SENDER_FILTER_MODE';
export const SET_KANBAN_INTERVENTION_FILTERS = 'INTERVENTIONS/KANBAN/SET/FILTERS';
export const REMOVE_KANBAN_INTERVENTION_FILTER = 'INTERVENTIONS/KANBAN/REMOVE/FILTER';
export const CLEAR_KANBAN_INTERVENTION_FILTER = 'INTERVENTIONS/KANBAN/CLEAR/FILTERS';

export const MOVE_KANBAN_INTERVENTION = 'INTERVENTIONS/KANBAN/MOVE_REQUEST';
export const MOVE_KANBAN_INTERVENTION_SUCCESS = 'INTERVENTIONS/KANBAN/MOVE_SUCCESS';
export const MOVE_KANBAN_INTERVENTION_FAILURE = 'INTERVENTIONS/KANBAN/MOVE_FAILURE';

/** MOBILITY TYPES */
export const FETCH_MOBILITY_INTERVENTIONS = 'INTERVENTIONS/MOBILITY/FETCH_REQUEST';
export const FETCH_MOBILITY_INTERVENTIONS_SUCCESS = 'INTERVENTIONS/MOBILITY/FETCH_SUCCESS';
export const FETCH_MOBILITY_INTERVENTIONS_FAILURE = 'INTERVENTIONS/MOBILITY/FETCH_FAILURE';

/** Mobility filters */
export const SET_MOBILITY_INTERVENTION_FILTER = 'INTERVENTIONS/MOBILITY/SET/FILTER';
export const SET_MOBILITY_INTERVENTION_FILTERS = 'INTERVENTIONS/MOBILITY/SET/FILTERS';
export const CLEAR_MOBILITY_INTERVENTION_FILTER = 'INTERVENTIONS/MOBILITY/CLEAR/FILTERS';
export const REMOVE_MOBILITY_INTERVENTION_FILTER = 'INTERVENTIONS/MOBILITY/REMOVE/FILTER';

export const PERSISTED_MOBILITY_ACTION_TYPES = [
  SET_MOBILITY_INTERVENTION_FILTER,
  SET_MOBILITY_INTERVENTION_FILTERS,
  CLEAR_MOBILITY_INTERVENTION_FILTER,
  REMOVE_MOBILITY_INTERVENTION_FILTER
];

export const PERSISTED_INTERVENTION = [
  SET_SORT,
  SET_SCHEDULABLE_TYPE,
  SET_INTERVENTIONS_FILTERS,
  SET_INTERVENTIONS_SENDER_FILTER_MODE,
  REMOVE_INTERVENTION_FILTER,
  CLEAR_INTERVENTIONS_FILTERS,
  SET_KANBAN_INTERVENTION_FILTER,
  SET_KANBAN_SENDER_FILTER_MODE,
  SET_KANBAN_INTERVENTION_FILTERS,
  CLEAR_KANBAN_INTERVENTION_FILTER,
  REMOVE_KANBAN_INTERVENTION_FILTER,
];

/** ACTIONS */
export const OPEN_MOBILITY_MODAL = 'INTERVENTIONS/MOBILITY/MODAL/OPEN';
export const CLOSE_MOBILITY_MODAL = 'INTERVENTIONS/MOBILITY/MODAL/CLOSE';
export const OPEN_MOBILITY_MODAL_READY = 'INTERVENTIONS/MOBILITY/MODAL/READY';

export const FETCH_MOBILITY_ITEM = 'INTERVENTION/MOBILITY/FETCH_REQUEST';
export const FETCH_MOBILITY_ITEM_SUCCESS = 'INTERVENTION/MOBILITY/FETCH_SUCCESS';
export const FETCH_MOBILITY_ITEM_FAILURE = 'INTERVENTION/MOBILITY/FETCH_FAILURE';

export const UPDATE_MOBILITY_ITEM = 'INTERVENTION/MOBILITY/PUT_REQUEST';
export const UPDATE_MOBILITY_ITEM_SUCCESS = 'INTERVENTION/MOBILITY/PUT_SUCCESS';
export const UPDATE_MOBILITY_ITEM_FAILURE = 'INTERVENTION/MOBILITY/PUT_FAILURE';

export const REMOVE_MOBILITY_INTERVENTION = 'INTERVENTION/MOBILITY/DASHBOARD/REMOVE_ENTRY';

export const OPEN_CHECKLISTS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/CHECKLISTS/OPEN_MODAL';
export const CLOSE_CHECKLISTS_IMPORT_MODAL = 'INTERVENTION/IMPORTS/CHECKLISTS/CLOSE_MODAL';
export const IMPORT_CHECKLISTS = 'INTERVENTION/IMPORTS/CHECKLISTS/REQUEST';
export const IMPORT_CHECKLISTS_SUCCESS = 'INTERVENTION/IMPORTS/CHECKLISTS/SUCCESS';
export const IMPORT_CHECKLISTS_FAILURE = 'INTERVENTION/IMPORTS/CHECKLISTS/FAILURE';

export const OPEN_RESEND_MODAL = 'INTERVENTION/RESEND/MODAL/OPEN';
export const CLOSE_RESEND_MODAL = 'INTERVENTION/RESEND/MODAL/CLOSE';

export const SET_EDITED_TIRE = 'INTERVENTION/TIRE/SET';
export const RESET_EDITED_TIRE = 'INTERVENTION/TIRE/RESET';

export const IMPORT_TIRE_REPORT = 'INTERVENTION/IMPORTS/TIRE_REPORT/REQUEST';
export const IMPORT_TIRE_REPORT_SUCCESS = 'INTERVENTION/IMPORTS/TIRE_REPORT/SUCCESS';
export const IMPORT_TIRE_REPORT_FAILURE = 'INTERVENTION/IMPORTS/TIRE_REPORT/FAILURE';

export const OPEN_CHECKLISTGROUP_MODAL = 'INTERVENTION/CHECKLISTGROUP/OPEN_MODAL';
export const CLOSE_CHECKLISTGROUP_MODAL = 'INTERVENTION/CHECKLISTGROUP/CLOSE_MODAL';

export const FOLLOW_FILE = 'INTERVENTION/FOLLOW_FILE/REQUEST';
export const FOLLOW_FILE_SUCCESS = 'INTERVENTION/FOLLOW_FILE/SUCCESS';
export const UNFOLLOW_FILE = 'INTERVENTION/UNFOLLOW_FILE/REQUEST';
export const UNFOLLOW_FILE_SUCCESS = 'INTERVENTION/UNFOLLOW_FILE/SUCCESS';

export const UPDATE_KIOSK_PREFERENCES = 'INTERVENTION/KIOSK_PREFERENCES_REQUEST';
export const UPDATE_KIOSK_PREFERENCES_SUCCESS = 'INTERVENTION/KIOSK_PREFERENCES_SUCCESS';

export const CREATE_DEFAULT_STOCK_CHECKLIST_REQUEST = 'INTERVENTION/CREATE_DEFAULT_STOCK_CHECKLIST/REQUEST';
export const CREATE_DEFAULT_STOCK_CHECKLIST_SUCCESS = 'INTERVENTION/CREATE_DEFAULT_STOCK_CHECKLIST/SUCCESS';
export const CREATE_DEFAULT_STOCK_CHECKLIST_FAILURE = 'INTERVENTION/CREATE_DEFAULT_STOCK_CHECKLIST/FAILURE';

export const OPEN_IMPORT_WORKS_MODAL = 'INTERVENTION/IMPORT/WORKS/MODAL/OPEN';
export const CLOSE_IMPORT_WORKS_MODAL = 'INTERVENTION/IMPORT/WORKS/MODAL/CLOSE';

export const FETCH_INTERVENTION_KANBAN_DETAILS_REQUEST = 'INTERVENTION/KANBAN/DETAILS/FETCH_REQUEST';
export const FETCH_INTERVENTION_KANBAN_DETAILS_SUCCESS = 'INTERVENTION/KANBAN/DETAILS/FETCH_SUCCESS';
export const FETCH_INTERVENTION_KANBAN_DETAILS_FAILURE = 'INTERVENTION/KANBAN/DETAILS/FETCH_FAILURE';

export const FETCH_LINKED_INTERVENTIONS_REQUEST = 'INTERVENTION/FETCH_LINKED/REQUEST';
export const FETCH_LINKED_INTERVENTIONS_SUCCESS = 'INTERVENTION/FETCH_LINKED/SUCCESS';
export const FETCH_LINKED_INTERVENTIONS_FAILURE = 'INTERVENTION/FETCH_LINKED/FAILURE';

export const PUSH_BACK_DMS_REQUEST = 'INTERVENTION/PUSH_BACK_DMS/REQUEST';
export const PUSH_BACK_DMS_SUCCESS = 'INTERVENTION/PUSH_BACK_DMS/SUCCESS';
export const PUSH_BACK_DMS_FAILURE = 'INTERVENTION/PUSH_BACK_DMS/FAILURE';

export const SEND_INTERVENTION_REQUEST = 'INTERVENTION/SEND_INTERVENTION_REQUEST';
export const SEND_INTERVENTION_SUCCESS = 'INTERVENTION/SEND_INTERVENTION_SUCCESS';
export const SEND_INTERVENTION_FAILURE = 'INTERVENTION/SEND_INTERVENTION_FAILURE';

export const POST_SEND_BY_REQUEST = 'INTERVENTION/SEND_BY/POST_REQUEST';
export const POST_SEND_BY_SUCCESS = 'INTERVENTION/SEND_BY/POST_SUCCESS';
export const POST_SEND_BY_FAILURE = 'INTERVENTION/SEND_BY/POST_FAILURE';

export const UPDATE_INTERVENTION_MEDIA_ORDER_REQUEST = 'INTERVENTION/MEDIA/ORDER/UPDATE_REQUEST';
export const UPDATE_INTERVENTION_MEDIA_ORDER_SUCCESS = 'INTERVENTION/MEDIA/ORDER/UPDATE_SUCCESS';
export const UPDATE_INTERVENTION_MEDIA_ORDER_FAILURE = 'INTERVENTION/MEDIA/ORDER/UPDATE_FAILURE';

export const FETCH_INSPECTIONS = 'INTERVENTION/INSPECTIONS/FETCH_REQUEST';
export const FETCH_INSPECTIONS_SUCCESS = 'INTERVENTION/INSPECTIONS/FETCH_SUCCESS';
export const FETCH_INSPECTIONS_FAILURE = 'INTERVENTION/INSPECTIONS/FETCH_FAILURE';

export const OPEN_ASSIGN_INSPECTION_MODAL = 'INTERVENTION/INSPECTIONS/ASSIGN_MODAL/OPEN';
export const CLOSE_ASSIGN_INSPECTION_MODAL = 'INTERVENTION/INSPECTIONS/ASSIGN_MODAL/CLOSE';

export const UPDATE_INTERVENTION_TAGS = 'INTERVENTION/TAGS/UPDATE_REQUEST';
export const UPDATE_INTERVENTION_TAGS_SUCCESS = 'INTERVENTION/TAGS/UPDATE_SUCCESS';
export const UPDATE_INTERVENTION_TAGS_FAILURE = 'INTERVENTION/TAGS/UPDATE_FAILURE';

export const EVALUATE_INTERVENTION_TAGS = 'INTERVENTION/TAGS/EVALUATE_REQUEST';
export const EVALUATE_INTERVENTION_TAGS_SUCCESS = 'INTERVENTION/TAGS/EVALUATE_SUCCESS';

export const FETCH_INTERVENTIONS_SELECT_REQUEST = 'INTERVENTIONS/SELECT/FETCH_REQUEST';
export const FETCH_INTERVENTIONS_SELECT_SUCCESS = 'INTERVENTIONS/SELECT/FETCH_SUCCESS';
export const CLEAR_INTERVENTIONS_SELECT = 'INTERVENTIONS/SELECT/CLEAR';
